import React from 'react';
import StoryPlayer from './StoryPlayer';

// Mock album data that matches your existing album payload structure
const mockAlbumData = {
  title: "Croatia Adventure",
  pages: [
    {
      photos: ["https://images.unsplash.com/photo-1555990538-c4d03f87f606?w=800"],
      imageUrl: "https://images.unsplash.com/photo-1555990538-c4d03f87f606?w=800",
      location: "Dubrovnik Old Town",
      title: "Dubrovnik Old Town",
      caption: "Arrived in the Pearl of the Adriatic! The ancient city walls are breathtaking.",
      journalText: null
    },
    {
      // Multiple photos - will show in grid layout
      photos: [
        "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800",
        "https://images.unsplash.com/photo-1533104816931-20fa691ff6ca?w=800"
      ],
      location: "City Walls & Sunset",
      title: "Walking the Walls",
      caption: "360° views of the Adriatic and golden hour magic",
      journalText: "Spent the afternoon walking the complete circuit of Dubrovnik's city walls. The sunset from the walls was absolutely spectacular."
    },
    {
      // Three photos - special grid layout
      photos: [
        "https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=800",
        "https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=800",
        "https://images.unsplash.com/photo-1567620905732-2d1ec7ab7445?w=800"
      ],
      location: "Local Restaurant",
      title: "Croatian Feast",
      caption: "Fresh seafood and local wine - perfection!",
      journalText: null
    },
    {
      photos: ["https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800"],
      imageUrl: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800",
      location: "Lokrum Island",
      title: "Island Escape",
      caption: "A short ferry ride to paradise",
      journalText: null
    },
    {
      // Two photos side by side
      photos: [
        "https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=800",
        "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800"
      ],
      location: "Beach Views",
      title: "Perfect Ending",
      caption: "Another day in paradise comes to a close",
      journalText: "Watched the sun dip below the horizon while reflecting on an incredible journey. Croatia exceeded every expectation."
    }
  ]
};

const StoryPlayerTest = () => {
  return (
    <div>
      <StoryPlayer album={mockAlbumData} />
    </div>
  );
};

export default StoryPlayerTest;
